module.exports = __webpack_public_path__ + "static/img/f_first_07.62d9bee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/f_first_07.png
// module id = CGiB
// module chunks = 9